import { render, staticRenderFns } from "./DepDotIndicator.component.vue?vue&type=template&id=95c43c9e&scoped=true&"
import script from "./DepDotIndicator.component.vue?vue&type=script&lang=js&"
export * from "./DepDotIndicator.component.vue?vue&type=script&lang=js&"
import style0 from "./DepDotIndicator.component.vue?vue&type=style&index=0&id=95c43c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c43c9e",
  null
  
)

export default component.exports